import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import Notifications from "react-notifications-menu";
import { Link } from "react-router-dom";
import pic4 from "../../img/pic4.jpeg";
import { IoMdNotifications } from "react-icons/io"
import { ToastContainer, toast } from "react-toastify";
// import {MdCancel} from 'react-icons/md'
import "react-toastify/dist/ReactToastify.css";
import { BiClipboard, BiHomeHeart, BiSupport } from "react-icons/bi";
import { FaDownload, FaRegFilePdf, FaUserFriends } from "react-icons/fa";
import { GiTrophyCup } from "react-icons/gi";
import { AiOutlineHome, AiTwotoneSetting } from "react-icons/ai";
import { BsPlusSquareFill, BsBook } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Trellosidebar from "../Trellosidebar";
import Modaal from "../Modaal/Modaal";
import Accordian from "../Accordian/Accordian";
import Starred from "../Starred/Starred";
import { Menu, SubMenu, Item } from "burger-menu";
import "burger-menu/lib/index.css";
import { CgMenuGridR, CgProfile } from "react-icons/cg";
import Createbtn from "../Createbtn/Createbtn";
import { GoSearch } from "react-icons/go";
import NavDropdown from "react-bootstrap/NavDropdown";
import { postTasks, deleteRoadMapService, putRoadmap } from "../../services/tasks/tasks";
import { IoMdHelpCircle } from "react-icons/io";
import CreateModal from "../../common-components/create-modal";
import { getUserData } from "../../services/auth/auth"
import { getNotification } from "../../services/InviteMember/InviteMembers"
import { updateNotification } from "../../services/InviteMember/InviteMembers"
import { useSelector } from 'react-redux'
import { MdCancel } from "react-icons/md";
// const DEFAULT_NOTIFICATION = {
//   image:
//     "https://cutshort-data.s3.amazonaws.com/cloudfront/public/companies/5809d1d8af3059ed5b346ed1/logo-1615367026425-logo-v6.png",
//   message: "Notification one.",
//   detailPage: "/events",
//   receivedTime: "12h ago",
// };
function Header(props) {
  const BoardsData = useSelector((state) => state.RoadmapSlice.RoadmapBoard)
  console.log("BoardsData", BoardsData)

  let { setToken, setGoogleToken } = props;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [accordianOpen, setaccordianOpen] = useState(false);
  const [Creatbtn, setCreatbtn] = useState(false);
  const [sterreedCont, setSterreedCont] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [taskText, setTastText] = useState("private");
  const [tasks, setTasks] = useState([]);
  const [apiTasks, setApiTasks] = useState([]);
  const [myLocalStorageData, setMyLocalStorageData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [data, setData] = useState("");
  const [inviteData, setInviteData] = useState([])
  const [handleFetch, setHandleFetch] = useState(false)
  const [state, setState] = useState(false);
  const [id, setId] = useState(null);
  const [googleUserData, setGoogleUserData] = useState([]);
  const [pic, setPic] = useState();
  const [showIcon, setShowIcon] = useState();
  const [stickyNav, setStickyNav] = useState(false);

  useEffect(() => {
    let userIdd = localStorage.getItem("userId");
    setId(userIdd)
    const data = localStorage.getItem("user");
    setMyLocalStorageData(JSON.parse(data));
    const googleData = localStorage.getItem("googleUser");
    setGoogleUserData(JSON.parse(googleData))
    // console.log("googleuserPic:", googleUserData)
    profileData(userIdd)
    notificationData(userIdd)
  }, [handleFetch]);
  let unseenInvited = inviteData?.filter((elm, index) => elm.view == false)
  const notifications = () => {
    // console.log("clicked notifications")
    updateNotification({ inviteId: id }).then((data) => {
      setData("")
      setHandleFetch(!handleFetch)
    }).catch((err) => {
      console.log(err)
    })
  }
  const notificationData = (userIdd) => {
    getNotification({ inviteId: userIdd }).then((data) => {
      setInviteData(data.data?.Invite)
    }).catch((err) => {
      console.log(err);
    })
  }
  const profileData = (userIdd) => {
    getUserData({ _id: userIdd }).then((data) => {
      setPic(data.data?.allData)
    }).catch((error) => {
      console.log(error)
    })
  }
  const addTask = () => {
    let arr = tasks;
    arr.push(taskText);
    setTasks(arr);
    setTastText("");
  };

  const saveTasks = () => {
    if (!userId) {
      toast.warn("You must login to create a Project");
      return;
    }
    let payload = {
      tasks: tasks,
      title: title,
      description: description,
      type: taskText,
      userId: userId,
    };

    postTasks(payload)
      .then((res) => {
        setState(true);
        console.log("res: ", res);
        setShowModal(false);
        console.log("id", res.id);
        navigate(`/roadmap/${res.id}`);
        setTitle("");
        setDescription("");
        setTastText("");
      })
      .catch((e) => {
        console.error(e);
      });
  };
  const navigate = useNavigate();
  const location = useLocation();
  const logOut = () => {
    localStorage.clear();
    setToken(null);
    setGoogleToken(null);
    navigate("/landing");
  };
  useEffect(() => {
    window.onscroll = () => {
      setStickyNav(window.pageYOffset === 0 ? false : true);
      return () => (window.onscroll = null);
    };
  }, []);


  return (
    <>
      <ToastContainer />
      <div className={stickyNav ? "header sticky-top" : "header"}>
        <Navbar className="main-navbar sticky-top" expand="lg" >
          <Navbar.Brand>
            <Link onClick={handleShow} className="side-button">
              <CgMenuGridR />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle className="togl" aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="home-to-profile-nav">
              <h6 className="text-dark heading">Roadmap</h6>
              &nbsp;&nbsp;
              <Nav.Link
                onClick={() => navigate("home")}
                className="nvbrdivzis mt-1"
              >
                Home
              </Nav.Link>
              <Nav.Link
                onClick={() => navigate("/")}
                className="nvbrdivzis mt-1"
              >
                Roadmaps
              </Nav.Link>
              <NavDropdown
                style={{ color: "black" }}
                className="nvbrdivzis mt-1"
                title="Projects"
                id="basic-nav-dropdown">
                <p className="recent__projects">
                  Recent
                </p>
                {
                  BoardsData?.map((item) => {
                    return <p className="recent__projects-title ">{item.title}</p>

                  })
                }
                <NavDropdown.Item>{
                }</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link
                    className="nvbrdivzis mt-1">
                    View All Projects
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.4">
                  <Link
                    className="nvbrdivzis mt-1">
                    Create Project
                  </Link>
                </NavDropdown.Item>
              </NavDropdown>
              {localStorage.getItem("user") ? (
                <Nav.Link className="navlink-last">
                  <button
                    className="button-7 mt-1"
                    role="button"
                    onClick={() => setShowModal(!showModal)}
                  >
                    Create
                  </button>
                </Nav.Link>
              ) : null}
              {location.pathname == "/trello" && (
                <button
                  className="butndivall"
                  onClick={() => {
                    setaccordianOpen(!accordianOpen);
                    setSterreedCont(false);
                    setCreatbtn(false);
                  }}
                >
                  Templates
                </button>
              )}
              {location.pathname == "/trello" && (
                <button
                  className="butndivalls"
                  onClick={() => {
                    setSterreedCont(!sterreedCont);
                    setCreatbtn(false);
                    setaccordianOpen(false);
                  }}
                >
                  Starred
                </button>
              )}
              {location.pathname == "/trello" && (
                <button
                  className="butndivallss"
                  onClick={() => {
                    setCreatbtn(!Creatbtn);
                    setSterreedCont(false);
                    setaccordianOpen(false);
                  }}
                >
                  Create
                </button>
              )}
              {location.pathname == "/trello" && Creatbtn && (
                <Createbtn setCreatbtn={setCreatbtn} />
              )}
              {location.pathname == "/trello" && sterreedCont && (
                <>
                  <Starred setSterreedCont={setSterreedCont} />
                </>
              )}
              <Form className="search d-flex mt-2" id="search__box">
                <span className="searchIcon">
                  <GoSearch className="search-baby" />
                </span>
                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="control"
                  aria-label="Search"
                />
              </Form>
              <div className="last__Div">
                <span onClick={() => setShowIcon(!showIcon)}><h6>{unseenInvited?.length > 0 ? unseenInvited.length : null}</h6><span onClick={notifications}>< IoMdNotifications className="span_notification" /></span></span>
              </div>
              {showIcon ? (

                <div className="h">
                  <div>
                    <h6 id="heading_h6">Notifications</h6>

                    <MdCancel className='close' size={30} color={"black"} onClick={() => setShowIcon(false)} />
                  </div>
                  {/* <button className='close' onClick={() => setShowIcon(!showIcon)}>X</button> */}
                  {inviteData.length > 0 ? (
                    inviteData.map(element => {
                      return (
                        <div className="h-card">
                          <h4 className="invited_board">{element.userId.name}
                            Invited you to board</h4>
                        </div>
                      )
                    })
                  ) : null
                  }
                </div>
              ) : (<></>)
              }
              &nbsp;&nbsp;
              <div className="mt-2">

                {
                  pic?.profilePicture ? (
                    <img src={`${process.env.REACT_APP_API_URL_IMG}/${pic.profilePicture}`} alt='' onClick={() => setIsOpen(!isOpen)}
                      className="profile" />

                  ) : (
                    <img
                      src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                      onClick={() => setIsOpen(!isOpen)}
                      className="profile"
                    ></img>
                  )
                }
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {location.pathname == "/trello" && <Trellosidebar />}
        {modalOpen && <Modaal setModalOpen={setModalOpen} />}
        {location.pathname == "/trello" && accordianOpen && (
          <Accordian setaccordianOpen={setaccordianOpen} />
        )}
        <Offcanvas className="one" show={show} onHide={handleClose}>
          {/* <Offcanvas.Header>
            {/* <Offcanvas.Title></Offcanvas.Title> */}
          {/* </Offcanvas.Header> */}
          <Offcanvas.Body className="offcanvas-body">
            <Card className="card">
              {/* <Card.Img variant="top" src={pic4} className="sideimg" /> */}
              <Card.Body className="body-card">
                <Card.Text>
                  <br></br>
                  <div className="home-div">
                    <AiOutlineHome className="iconss" />
                    <h4 className="home-h4">
                      <a href="#" className="a">
                        Home
                      </a>
                    </h4>
                  </div>
                  <br></br>
                  <div className="home-div">
                    <FaDownload className="iconss" />
                    <h4 className="home-h4">
                      <a href="#" className="a">
                        Your Boards
                      </a>
                    </h4>
                  </div>
                  <br></br>

                  {/* <div className="home-div">
                    <BsPlusSquareFill className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("create")}
                      style={{ cursor: "pointer" }}
                    >
                      Create Roadmap
                    </h4>
                  </div> */}
                  {/* <br></br> */}

                  <div className="home-div">
                    <BsBook className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("content")}
                      style={{ cursor: "pointer" }}
                    >
                      Content
                    </h4>
                  </div>
                  <br></br>
                  {/*
                  <div className="home-div">
                    <GiTrophyCup className="iconss" />
                    <h4 className="home-h4">
                      <a href="#" className="a">
                        Top Scorers
                      </a>
                    </h4>
                  </div>
                  <br></br> */}

                  {/* <div className="home-div">
                    <FaUserFriends className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("AddMembers")}
                      style={{ cursor: "pointer" }}
                    >
                      Add Members
                    </h4>
                  </div>
                  <br></br> */}
                  <div className="home-div">
                    <GiTrophyCup className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("/trello")}
                      style={{ cursor: "pointer" }}
                    >
                      Trello Board
                    </h4>
                  </div>
                  <br></br>

                  {/* <div className="home-div">
                    <BiClipboard className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("/board")}
                      style={{ cursor: "pointer" }}
                    >
                      Todo Board
                    </h4>
                  </div> */}
                  {/* <br></br> */}
                  <div className="home-div">
                    <FaRegFilePdf className="iconss" />
                    <h4
                      className="home-h4"
                      onClick={() => navigate("/UserForm")}
                      style={{ cursor: "pointer" }}
                    >
                      Portfolio Builder
                    </h4>
                  </div>

                  <br></br>

                  <div className="home-div">
                    <AiTwotoneSetting className="iconss" />
                    <h4 className="home-h4">
                      <a href="#" className="a">
                        Setting
                      </a>
                    </h4>
                  </div>
                  <br></br>

                  <div className="home-div">
                    <BiSupport className="iconss" />
                    <h4 className="home-h4">
                      <a href="#" className="a">
                        Support
                      </a>
                    </h4>
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      {/* <br></br> */}
      {isOpen ? (
        <Menu
          animate="fallDown"
          className="burger-menu"
          isOpen={isOpen}
          selectedKey={"entry"}
          onClose={() => setIsOpen(false)}
        >
          <div className="boarddivcntr">Account</div>
          <div className="user__profile">
            {
              pic?.profilePicture ? (
                <img src={`${process.env.REACT_APP_API_URL_IMG}/${pic.profilePicture}`} alt='' className="pic" />
              ) : (<img
                src={require("./../../img/profile-icon-9.png")}
                alt="pic"
                className="profile__pic"
              />)
            }
            <div className="user__name mt-5">
              <p>
                <span className="user__name">{myLocalStorageData?.name}</span>
              </p>
              <p>
                <span className="user__email">{myLocalStorageData?.email}</span>
              </p>
            </div>
          </div>
          <div className="items">
            <Link to="UserProfile">
              <div className="item">
                <p>Profile</p>
              </div>
            </Link>
            <div className="item">
              <p>Personal Settings</p>
            </div>
            <div className="item" onClick={logOut}>
              <p>Logout</p>
            </div>
          </div>
        </Menu>
      ) : null
      }
      {<CreateModal showModal={showModal} setShowModal={setShowModal} />}
    </>
  );
}
export default Header;